import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Login from "../views/LoginPage";
import Portfolio from "../views/PortfolioPage";
import SystemAdmin from "../views/SystemAdminPage";
import ProjectManagement from "../views/SystemAdminPage/ProjectManage";
import ProjectDetails from "../views/SystemAdminPage/ProjectDetails";
import UserManagement from "../views/SystemAdminPage/UserManage";
import UserDetails from "../views/SystemAdminPage/UserDetails";
import ProjectHome from "../views/ProjectHomePage";
import Model from "../views/3DModelPage";
import Schedule from "../views/SchedulePage";
import Cost from "../views/CostPage";
import Safety from "../views/SafetyPage";
import Quantity from "../views/QuantityPage";
import Observation from "../views/ObservationPage";
import Report from "../views/ReportPage";
import SitePhoto from "../views/SitePhotoPage";

const ModuleController = () => {
  const { moduleName, projectId } = useParams();
  const navigate = useNavigate();
  if (moduleName && projectId) {
    switch (moduleName) {
      case "ProjectAdmin":
        return <ProjectDetails />;
      case "ProjectDetails":
        return <ProjectDetails />;
      case "UserDetails":
        return <UserDetails />;
      case "Project":
        return <ProjectHome />;
      case "3DModel":
        return <Model />;
      case "Cost":
        return <Cost />;
      case "Schedule":
        return <Schedule />;
      case "Safety":
        return <Safety />;
      case "Quantity":
        return <Quantity />;
      case "Report":
        return <Report />;
      case "SitePhoto":
        return <SitePhoto />;
      case "Observation":
        return <Observation />;
      default:
        return <Login />;
    }
  } else if (moduleName === "Portfolio") {
    return <Portfolio />;
  } else if (moduleName === "SystemAdmin") {
    return <SystemAdmin />;
  } else if (moduleName === "ProjectManagement") {
    return <ProjectManagement />;
  } else if (moduleName === "UserManagement") {
    return <UserManagement />;
  } else if (moduleName) {
    navigate(`/modules/Portfolio`);
  } else {
    return <Login />;
  }
};

export default ModuleController;
